exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".router .weui_cell[data-v-736d5eff]{height:.66666667rem;line-height:.5rem}", ""]);

// exports
